import { useLanguage } from "../../../stores/LanguageStore";
import { Group, NumberInput, Select, TextInput } from "@mantine/core";
import FilterValueSelector from "./FilterValueSelector";
import FilterDateSelector from "./FilterDateSelector";
import FilterLazyValue from "./FilterLazyValue";
import FilterLeadsCampaign from "./FilterLeadsCampaign";
import FilterDateRangeSelector from "./FilterDateRangeSelector";
import FilterLeadsStatus from "./FilterLeadsStatus";
import FilterWorkflowStep from "./FilterWorkflowStep";

const FilterValue = ({
  type = "text",
  value,
  setValue,
  valueOptions,
  disabled,
  getter,
  responseField,
  storeKey,
  setStoreKey,
  nameField,
  groups,
  label,
  singleSelectOptions,
  filterItems,
  field_name,
  handleResponse,
  setCondition,
  pageName,
  free,
  isMobile,
  disableEdit,
  nullable
}) => {
  const lang = useLanguage((s) => s.language);

  const getComponent = () => {
    if (type === "date") {
      return (
        <FilterDateSelector
          value={value}
          placeholder={"Date"}
          disabled={disabled}
          setValue={setValue}
          setCondition={setCondition}
          field_name={field_name}
          pageName={pageName}
          isMobile={isMobile}
          readOnly={disableEdit}
        />
      );
    }
    if (type === "date_range") {
      return (
        <FilterDateRangeSelector
          value={value}
          disabled={disabled}
          setValue={setValue}
          readOnly={disableEdit}
        />
      );
    }
    if (type === "workflow_step") {
      return (
        <FilterWorkflowStep
          setValue={setValue}
          value={value}
          isMobile={isMobile}
          readOnly={disableEdit}
        />
      );
    }
    if (type === "lazy") {
      return (
        <FilterLazyValue
          getter={getter}
          responseField={responseField}
          label={label}
          setValue={setValue}
          value={value}
          storeKey={storeKey}
          setStoreKey={setStoreKey}
          nameField={nameField}
          groups={groups}
          filterItems={filterItems}
          field_name={field_name}
          handleResponse={handleResponse}
          free={free}
          isMobile={isMobile}
          readOnly={disableEdit}
          nullable={nullable}
        />
      );
    }
    if (type === "campaign") {
      return (
        <FilterLeadsCampaign
          setValue={setValue}
          value={value}
          isMobile={isMobile}
          readOnly={disableEdit}
        />
      );
    }
    if (type === "leads_status") {
      return <FilterLeadsStatus setValue={setValue} value={value} />;
    }
    if (valueOptions) {
      return (
        <FilterValueSelector
          label={label}
          options={valueOptions}
          value={value}
          setValue={setValue}
          disabled={disabled}
          readOnly={disableEdit}
          nullable={nullable}
        />
      );
    }
    if (type === "number") {
      return (
        <NumberInput
          value={value === undefined ? null : parseInt(value)}
          onChange={(v) => {
            setValue(v?.toString() || "");
          }}
          placeholder={
            lang.table.toolbar.filter.values.value_placeholder + " *"
          }
          required
          w={isMobile ? "100%" : 150}
          disabled={disabled}
          readOnly={disableEdit}
        />
      );
    }
    if (type === "singleSelect") {
      return (
        <Select
          value={value}
          onChange={setValue}
          placeholder={
            lang.table.toolbar.filter.values.value_placeholder + " *"
          }
          data={singleSelectOptions}
          required={!nullable}
          autoFocus
          w={isMobile ? "100%" : 150}
          disabled={disabled}
          readOnly={disableEdit}
        />
      );
    }
    return (
      <TextInput
        type={type}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={lang.table.toolbar.filter.values.value_placeholder + " *"}
        required={!nullable}
        autoFocus
        w={isMobile ? "100%" : 150}
        disabled={disabled}
        readOnly={disableEdit}
      />
    );
  };

  return <Group miw={isMobile ? "100%" : 175}>{getComponent()}</Group>;
};

export default FilterValue;
